import i18n from 'src/i18n';
import moment from 'moment';
import { uiShowPreLoader, uiHidePreLoader, } from 'src/store/ui-reducer';

import actionTypes from './actionTypes';
import { localAppointmentsFilters } from '../../services/appointments';
import { STATUS_PAID, STATUS_CANCELLED, ROLES, STATUS_REPLACED } from 'services/constants';

// Services
import { alertError, alertInfo } from 'services/alerts';
import { isToday, dateForRequest } from 'services/date';
import { bookingApi, communicateApi } from 'services/http';
import { requestForHandlePayConfirm } from '../../services/payments';

import { testAppointmentsVerdonk } from '../../../../__mock__/UG';

//──── Filters ───────────────────────────────────────────────────────────────────────────
// Appointments statuses
export const setFilterAppointmentsStatuses = statusesList => {
  const locKey = 'selectedAppointmentStatus';
  const localFilterData = localAppointmentsFilters.get(locKey);
  let results;
  if (localFilterData) {
    results = localFilterData;
  } else {
    results = statusesList;
    localAppointmentsFilters.set({ [locKey]: statusesList });
  }

  return {
    type: actionTypes.SET_FILTER_APPOINTMENT_STATUSES,
    payload: results
  };
};

export const updateFilterAppointmentsStatus = status => {
  return {
    type: actionTypes.UPDATE_FILTER_APPOINTMENT_STATUS,
    payload: status
  };
};

//──── Appointments ──────────────────────────────────────────────────────────────────────

export const clearList = () => ({ type: actionTypes.CLEAR_LIST });

// const removeTodayCancelAppointment = list => {
//   if (list && typeof list === 'object' && list.length) {
//     return list.filter(i => i.status !== STATUS_CANCELLED);
//   }
//   return [];
// };

export const sortedList = appointmentsList => {
  if (Array.isArray(appointmentsList)) {
    // server must return utc date
    const convertToCommonFormat = appointmentsList.map(el => {
      if (el && el.dateTime && !el.dateTime.match('Z')) {
        el.dateTime = `${el.dateTime}Z`;
      }
      return el;
    });

    const sortedList = convertToCommonFormat.sort(
      (a, b) => new Date(a.dateTime) - new Date(b.dateTime)
    );
    // return sortedList.length && sortedList[0].dateTime && isToday(sortedList[0].dateTime)
    //   ? removeTodayCancelAppointment(sortedList)
    //   : sortedList;
    return sortedList;
  }
};

export const loadAppointmentsByPractId = (doctorId, momentDate) => async (dispatch, getStore) => {
  const store = getStore();
  const {
    auth,
    practitioner: { common }
  } = store;
  const date = momentDate || moment();
  const practitionerId =
    doctorId || (common && common.commonFilters && common.commonFilters.practitionerId);

  // dispatch(loadAppointmentsSuccess(sortedList(testAppointmentsVerdonk))); // mock data
  if (auth && auth.isAuthenticated && practitionerId &&
    (auth.role === ROLES.STAFF || auth.role === ROLES.PRACTITIONER || auth.role === ROLES.RADIOLOGY)
  ) {
    dispatch(uiShowPreLoader());

    bookingApi
      .get(`practitioners/${practitionerId}/bookings`, {
        params: {
          startDateTime: dateForRequest(date.startOf('day')),
          endDateTime: dateForRequest(date.endOf('day'))
        },
        withoutLoader: true
      })
      .then(({ data }) => {
        dispatch(loadAppointmentsSuccess(sortedList(data)));
        dispatch(uiHidePreLoader());
      })
      .catch(({ response }) => {
        if (response && response.status !== 400 && response.status !== 401) {
          alertError();
        }
        dispatch(loadAppointmentsError());
        dispatch(uiHidePreLoader());
      });
  }
};

const loadAppointmentsSuccess = list => ({
  type: actionTypes.LOAD_TODAY_APPOINTMENTS_SUCCESS,
  payload: { list }
});

const loadAppointmentsError = () => ({
  type: actionTypes.LOAD_TODAY_APPOINTMENTS_ERROR,
  payload: []
});

//──── Cancel appointments ───────────────────────────────────────────────────────────────
export const cancelAppointments = (list) => dispatch => {
  dispatch(uiShowPreLoader());
  return bookingApi
    .post('/appointments/notice', { externalAppointmentIds: list })
    .then(() => {
      dispatch(uiHidePreLoader());
      alertInfo(i18n.t('canceling_page_success_toast'));
      return true;
    })
    .catch(err => {
      const { response } = err;
      if ((response && response.status !== 401) || !response) {
        alertError();
      }
      dispatch(uiHidePreLoader());
      throw new Error(err);
    });
};

//──── Unplanned Appointments ────────────────────────────────────────────────────────────

export const loadUnplannedAppointments = () => (dispatch, getStore) => {
  const store = getStore();
  const { auth } = store;
  if (auth && auth.isAuthenticated &&
    (auth.role === ROLES.STAFF || auth.role === ROLES.PRACTITIONER)
  ) {
    bookingApi
      .get('/appointments/unplanned', {
        withoutLoader: true,
        params: {
          today: dateForRequest(moment())
        }
      })
      .then(({ data }) => {
        const sortList =
          Array.isArray(data) &&
          data.sort(
            (a, b) => (moment(a.createdDateTime).isBefore(moment(b.createdDateTime)) ? -1 : 1)
          );
        dispatch({ type: actionTypes.SET_UNPLANNED_APPOINTMENTS, payload: sortList });
      })
      .catch(({ response }) => {
        if (
          response &&
          response.status !== 400 &&
          response.status !== 401 &&
          response.status !== 404
        ) {
          alertError();
        }
      });
  }
};

const removeUnpApById = id => ({
  type: actionTypes.REMOVE_UNPLANNED_APPOINTMENT_BY_ID,
  payload: id
});

export const rejectUnpApById = (id, note) => dispatch => {
  dispatch(uiShowPreLoader());
  return bookingApi
    .delete(`/appointments/${id}/unplanned`, { data: { note } })
    .then(() => {
      dispatch(removeUnpApById(id));
      dispatch(uiHidePreLoader());
    })
    .catch(err => {
      const { response } = err;
      if ((response && response.status !== 401) || !response) {
        alertError();
      }
      dispatch(uiHidePreLoader());
      throw new Error(err);
    });
};

export const addUnpAp = (id, clarifyingData) => dispatch => {
  dispatch(uiShowPreLoader());
  return bookingApi
    .post(`/appointments/${id}/unplanned`, { ...clarifyingData })
    .then(() => {
      dispatch(removeUnpApById(id));
      dispatch(uiHidePreLoader());
    })
    .catch(err => {
      const { response } = err;
      if ((response && response.status !== 401) || !response) {
        alertError();
      }
      dispatch(uiHidePreLoader());
      throw new Error(err);
    });
};

export const replaceAp = (unplannedApId, clarifyingData, ugAppointmentId) => dispatch => {
  dispatch(uiShowPreLoader());
  return bookingApi
    .post(`/appointments/${ugAppointmentId}/unplanned/${unplannedApId}`, { ...clarifyingData })
    .then(() => {
      dispatch(removeUnpApById(unplannedApId));
      dispatch(
        updateSingleAppointmentInList(ugAppointmentId, {
          appointment: { viewModel: { state: STATUS_REPLACED } }
        })
      );
      dispatch(uiHidePreLoader());
    })
    .catch(err => {
      const { response } = err;
      if ((response && response.status !== 401) || !response) {
        alertError();
      }
      dispatch(uiHidePreLoader());
      throw new Error(err);
    });
};

//──── Appointment ───────────────────────────────────────────────────────────────────────

export const updateSingleAppointmentInList = (appointmentId, dataObj) => ({
  type: actionTypes.UPDATE_SINGLE_APPOINTMENT_IN_LIST,
  payload: { appointmentId, dataObj }
});

export const resetSingleAppointmentInList = (appointmentId, newAppointment) => ({
  type: actionTypes.RESET_SINGLE_APPOINTMENT_IN_LIST,
  payload: { appointmentId, newAppointment }
});

//──── Confirm payment methods in list ───────────────────────────────────────────────────

export const confirmPaymentMethodInList = (invoice, appointmentId, paymentMethod) => dispatch => {
  return requestForHandlePayConfirm(invoice, paymentMethod).then(
    () => {
      // success
      dispatch(updateSingleAppointmentInList(appointmentId, { status: STATUS_PAID }));
      dispatch(confirmPaymentMethodInListSuccess());
    },
    err => {
      const errRes = err.response;
      if (errRes && errRes.data && errRes.data.Codes && errRes.data.Codes.length) {
        const codesList = errRes.data.Codes;
        if (codesList.find(el => String(el) === '102')) {
          // invoice was changed
          dispatch(confirmPaymentMethodInListError());
          throw new Error('toast_payment_changed_reception');
        } else if (
          codesList.find(el => String(el) === '202') ||
          codesList.find(el => String(el) === '201')
        ) {
          // user was starting paid invoice
          alertError(i18n.t('invoice_in_process_popup_text'));
          dispatch(confirmPaymentMethodInListError());
        } else {
          dispatch(confirmPaymentMethodInListError());
        }
      } else {
        dispatch(confirmPaymentMethodInListError());
      }
    }
  );
};

const confirmPaymentMethodInListSuccess = () => ({
  type: actionTypes.UPDATE_SINGLE_APPOINTMENT_IN_LIST_SUCCESS
});

const confirmPaymentMethodInListError = () => ({
  type: actionTypes.UPDATE_SINGLE_APPOINTMENT_IN_LIST_ERROR
});

export const clearPractitionerId = () => ({
  type: actionTypes.CLEAR_PRACTITIONER_ID
});
